import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {store,persistor} from "./Redux/store";
// import persistor from "./Redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import './i18n'
import { register } from './serviceWorkerRegistration';


const root = ReactDOM.createRoot(document.getElementById("root"));
register();
root.render(
  <React.StrictMode>
        <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
